import { I18nextProvider } from 'react-i18next';

import { createI18n } from '#core/i18n/i18n.ts';

import { resources } from '#i18n/resources.ts';

const i18n = createI18n(resources);

export function AppProvider({ children }: React.PropsWithChildren) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
